import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from '@/components/buttons/Button';
import CloseButton from '@/components/UI/Buttons/CloseButton';
import { useRegistration } from '@/hooks/useRegistration';
import { GTagEvents, OpenedFrom, triggerGTag } from '@/lib/gTagManager';
import { BaseModalProps } from '@/features/modal/types';
import { selectExitIntentOffer } from '@/store/cms/welcome-texts/selectors';
import { clearPendingNavigation } from '@/pages/games/game/useFreeToPlayExitIntent';

export const FreeToPlayExitModal = ({ closeModal }: BaseModalProps) => {
  const intl = useIntl();
  const { openRegistration } = useRegistration();
  const exitIntentOffer = useSelector(selectExitIntentOffer);

  const handleCreateAccount = () => {
    triggerGTag(GTagEvents.f2p_exit_intent_register);
    clearPendingNavigation();
    closeModal();
    openRegistration({ openedFrom: OpenedFrom.Game });
  };

  return (
    <div
      className="w-[350px] rounded-lg bg-slate-50 transition-all duration-1000 ease-in-out"
      data-cy="free-to-play-exit-intent"
    >
      <div className="relative flex flex-col items-center justify-center space-y-6 pb-12 p-8">
        <CloseButton left onClick={() => closeModal()} />
        <div className="text-center">
          <h2 className="m-0 text-2xl font-bold">
            {intl.formatMessage({ id: 'game.exitIntent.title' })}
          </h2>
          <p className="mb-0 mt-2 text-base">
            {intl.formatMessage({ id: 'game.exitIntent.subtitle' })}{' '}
            <span
              className="cursor-pointer font-bold text-blue-light"
              onClick={handleCreateAccount}
            >
              {intl.formatMessage({ id: 'game.exitIntent.subtitleHighlight' })}
            </span>
          </p>
        </div>
        {exitIntentOffer && (
          <div className="text-center text-lg font-extralight">
            <div className="[&_p]:m-0 [&_p]:p-0 [&_strong]:text-blue-light">{exitIntentOffer}</div>
          </div>
        )}
        <div className="flex w-[200px] flex-col items-center ">
          <Button
            onClickHandler={handleCreateAccount}
            btnType="primary"
            text={intl.formatMessage({ id: 'game.exitIntent.cta' })}
          />
        </div>
      </div>
    </div>
  );
};
